/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DefaultMetaDataDTO } from '../models/DefaultMetaDataDTO';
import type { UIMetaDataDTO } from '../models/UIMetaDataDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UiMetaDataService {

    /**
     * @param clientId 
     * @returns UIMetaDataDTO Success
     * @throws ApiError
     */
    public static getBackendv2UimetadataBackendlist(
clientId?: number,
): CancelablePromise<Array<UIMetaDataDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backendv2/uimetadata/backendlist',
            query: {
                'clientId': clientId,
            },
        });
    }

    /**
     * @param clientId 
     * @param assetType 
     * @returns DefaultMetaDataDTO Success
     * @throws ApiError
     */
    public static getBackendv2UimetadataDefaults(
clientId?: number,
assetType?: string,
): CancelablePromise<Array<DefaultMetaDataDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backendv2/uimetadata/defaults',
            query: {
                'clientId': clientId,
                'assetType': assetType,
            },
        });
    }

}
